import { FC, useState } from 'react';

import { Drawer, Flex } from 'antd';

import useIsMobile from '@/hooks/useIsMobile';

import BurgerIcon from '@/assets/icons/burger.svg?react';

import styles from './FormMobileHeader.module.scss';

import Close from '../icons/Close';
import Logo from '../logo/Logo';

import { TimeLine } from '@/components';

export const FormMobileHeader: FC = () => {
	const [drawerOpened, setDrawerOpened] = useState(false);

	const toggleDrawerOpen = (): void => {
		setDrawerOpened((prev) => !prev);
	};

	const isMobile = useIsMobile();

	return (
		<>
			<Flex className={styles['form-header']} justify="space-between">
				<Logo />
				<BurgerIcon className={styles['menu-icon']} onClick={toggleDrawerOpen} />
			</Flex>
			<Drawer
				classNames={{
					body: styles['drawer-body'],
					header: styles['drawer-header'],
					content: styles['drawer-content'],
				}}
				closeIcon={<Close />}
				open={drawerOpened}
				title={<Logo />}
				width={isMobile ? '100vw' : 375}
				onClose={toggleDrawerOpen}
			>
				<TimeLine onChangeStep={toggleDrawerOpen} />
			</Drawer>
		</>
	);
};
